import type { Plan } from '@/core/domain';
import {
  CHOOSE_PLAN_FREE_BENEFITS_TAIL,
  CHOOSE_PLAN_FREE_DEFAULT_MAX_SERVICES_PER_MONTH,
} from '@/features/plans/presentation/composables/constants/choose-plan-screen.constants';

/**
 * Benefícios do card grátis (primeira linha usa `free_limits.max_services`).
 */
export function buildFreePlanBenefitLines(plan: Plan | null): readonly string[] {
  const max = plan?.free_limits?.max_services ?? CHOOSE_PLAN_FREE_DEFAULT_MAX_SERVICES_PER_MONTH;
  const servicesLine =
    max <= 0 ?
      'Sem registro de serviços neste plano'
    : `Registro de até ${max} serviços por mês`;

  return [servicesLine, ...CHOOSE_PLAN_FREE_BENEFITS_TAIL];
}
